import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocaleService } from './services/locale/locale.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('ta-admin-fe');

  constructor(private localeService: LocaleService) {}
}
